/**
 * Map a Models-page training row (+ optional live usecase doc) to the shape
 * ``ObjectiveTabs`` / ``ObjectiveTabLabel`` expect.
 */
export function trainingToTabUsecase(training, usecase = null) {
  if (usecase) {
    return {
      _id: usecase._id,
      usecase_name:
        usecase.usecase_name || training.objective_name || training.usecase_name,
      task_type: usecase.task_type || training.task_type,
      is_multilabel: usecase.is_multilabel,
      classify_speakers: usecase.classify_speakers,
    };
  }
  return {
    _id: training.llm_usecase_id,
    usecase_name: training.objective_name || training.usecase_name,
    task_type: training.task_type,
    is_multilabel: training.is_multilabel,
    classify_speakers: training.classify_speakers,
  };
}
